import { OrderApiDto, OrderStatusDefinitionIdentifier } from '@order-mage/integration-sdk';
import dayjs from 'dayjs';

export type OrderExpiryInput = Pick<OrderApiDto, 'status' | 'scheduledAt'>;

export const getOrderExpiresAt = (order: OrderExpiryInput): dayjs.Dayjs => {
    if (
        order.status.definition.identifier === OrderStatusDefinitionIdentifier.POSTPONED &&
        order.scheduledAt
    ) {
        const scheduledAt = dayjs(order.scheduledAt);
        if (scheduledAt.isValid()) {
            return scheduledAt.add(12, 'hour');
        }
    }
    return dayjs(order.status.updatedAt).add(12, 'hour');
};
